import genericFormReducer from './reducers';

export default genericFormReducer;
